import { TableRow } from "./constants";

export function transformDataForPivot(apiData: any[]): TableRow[] {
  if (!apiData || apiData.length === 0) return [];

  // Helper to get value or fallback
  const get = (row: any, key: string) => row[key] ?? "";

  // New Acq. row: only for the first month

  // Dynamic renewal rows: skip the first month
  const renewalRows: TableRow[] = apiData.slice(0)?.map((row, idx) => ({
    label: `${row.MonthYear.split("-")[0]}-Auto Top-up`,
    users: get(row, "Users"),
    paidUsers: get(row, "Paid"),
    unpaidUsers: get(row, "UnPiad"),
    monthData: apiData?.map((r, i) => ({
      AutoTopup: i === idx ? get(r, "Success") : 0,
      AutoTopupFailed: i === idx ? get(r, "Failure") : 0,
    })),
  }));

  // Totals row

  // Summary/statistics rows
  const usagePercentRow: TableRow = {
    label: "Usage %",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "Usage%") !== "" ? `${get(row, "Usage%")}%` : "",
    })),
    bg: "#ffebee",
    isSummary: true,
  };

  const allocatedMinsRow: TableRow = {
    label: "Allocated Mins",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "Total_Minuts") !== "" ? `${get(row, "Total_Minuts")}` : "",
    })),
    bg: "#eaf6ff",
    isSummary: true,
  };

  const usedMinsRow: TableRow = {
    label: "Used Mins",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "Used_Mints"),
    })),
    isSummary: true,
  };

  const retentionRow: TableRow = {
    label: "Retention Users",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "Retention"),
    })),
    isSummary: true,
  };

  const autoTopupRevRow: TableRow = {
    label: "Auto Top-ups Revenue",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "AutoTopUp_Rev") !== "" ? `£${get(row, "AutoTopUp_Rev")}` : "",
    })),
    isSummary: true,
  };

  const welcomeBundleSalesRow: TableRow = {
    label: "Welcome Bundle Sales Revenue",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "WelcomeBundleSaleRev") !== ""
          ? `£${get(row, "WelcomeBundleSaleRev")}`
          : "",
    })),
    isSummary: true,
  };

  const totalOtherPlansRow: TableRow = {
    label: "Buy any other Bundle",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "TotalOtherPlan"),
    })),
    isSummary: true,
  };

  const otherBundleRevRow: TableRow = {
    label: "Revenue from other Bundles",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "OtherPlanRev") !== "" ? `£${get(row, "OtherPlanRev")}` : "",
    })),
    isSummary: true,
  };

  const accountTopupsCountRow: TableRow = {
    label: "Account Topups Count",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "TotalTopup"),
    })),
    isSummary: true,
  };

  const revenueFromAccountTopupsRow: TableRow = {
    label: "Revenue from Account Top-ups",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "TopupAmount") !== "" ? `£${get(row, "TopupAmount")}` : "",
    })),
    isSummary: true,
  };
  const mobileTopupsCountRow: TableRow = {
    label: "Mobile Topups Count",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "TotalMobileTopup"),
    })),
    isSummary: true,
  };

  const mobileTopupsRevRow: TableRow = {
    label: "Revenue from Mobile Top-ups",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "MobileTopupAmount") !== ""
          ? `£${get(row, "MobileTopupAmount")}`
          : "",
    })),
    isSummary: true,
  };
  const totalPaymentRow: TableRow = {
    label: "Total Payment Made",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed:
        get(row, "TotalPaymentMade") !== ""
          ? `£${get(row, "TotalPaymentMade")}`
          : "",
    })),
    isSummary: true,
  };

  const ltvRow: TableRow = {
    label: "LTV",
    monthData: apiData?.map((row) => ({
      AutoTopup: "",
      AutoTopupFailed: get(row, "LTV") !== "" ? `£${get(row, "LTV")}` : "",
    })),
    bold: true,
    bg: "#e3f2fd",
    isSummary: true,
  };

  return [
    ...renewalRows,
    usagePercentRow,
    allocatedMinsRow,
    usedMinsRow,
    retentionRow,
    autoTopupRevRow,
    welcomeBundleSalesRow,
    otherBundleRevRow,
    totalOtherPlansRow,
    accountTopupsCountRow,
    revenueFromAccountTopupsRow,
    mobileTopupsCountRow,
    mobileTopupsRevRow,
    totalPaymentRow,
    ltvRow,
  ];
}
